import { AiResult, StructuredSummaryResult, StructuredSummaryResultType } from '../../../../../../../models/AiResult'
import { useEffect, useState } from 'react'
import { isObject } from '../../../../../../../common/util'
export interface FamilyTreeResult {
  name?: string
  relationship?: string
  information?: string[]
}
export const useFamilyTreeResult = (aiResult: AiResult): FamilyTreeResult[] => {
  const [familyResults, setFamilyResults] = useState<FamilyTreeResult[]>([])

  useEffect(() => {
    if (aiResult.result) {
      const structuredSummaryResult = aiResult.result as StructuredSummaryResult
      const mappedResults = (structuredSummaryResult.result as StructuredSummaryResultType[])
        .map((result) => {
          if (isObject(result)) {
            const objectResult = result as { [key: string]: StructuredSummaryResultType | StructuredSummaryResultType[] }
            return {
              name: objectResult.Name,
              relationship: objectResult.Relationship,
              information: objectResult.Information,
            } as FamilyTreeResult
          }
          return null
        })
        .filter((result): result is FamilyTreeResult => !!result)
      setFamilyResults(mappedResults)
    }
  }, [aiResult])

  return familyResults
}
